<template>
		<el-col :span="24" id="footer">
            <div class="footer_top boxSizing">
                <div class="centerMain">
                    <img :src="$store.state.systemInfo.blackLogo" alt="" style="float:left">
                    <ul class="fr" style="color:#837A78; font-size: 15px;">
                    <br>
                    <p>办公地址：北京市西城区长椿街45号 </p>
                    <p>
                       010-83198836&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;volunteerdocs@163.com</p>
                    <p>深圳分部：深圳市南山区科兴科学园A2栋1303</p>
                    <p>0755-86718774&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;volunteerdocs@fmankind.com</p>
                    </ul>
                </div>
            </div>
            <div class="footer_bottom">
                <div class="centerMain">
                      <!--公安部备案-->
                    <div class="f1">
		 		    <a target="_blank"  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102005707"><img src="/static/images/beian.png" style="float:left;margin: 20px 0px 20px 5px;"/><p style="font-size:14px;float:left;height:20px;line-height:20px;margin: 20px 0px 0px 5px; color:#939393;">{{$store.state.systemInfo.beianStr}}</p></a>
		 	        </div>
                    <div class="fl" style="margin-left:95px;">Copyright 2018.All rights reserved.</div>
                     <!--工信部备案-->
                    <div class="f1">
		 		    <a  target="_blank"  href="https://beian.miit.gov.cn/"><p style="font-size:14px;float:left;height:20px;line-height:20px;margin: 20px 0px 0px 5px; color:#939393;">{{$store.state.systemInfo.CopyrightStr}}</p></a>
		 	        </div>
                    <!--
                    <div class="fr">CopyRight © 2018 中国志愿医生 版权所有 京ICP备18012326号-1</div>
                    -->
                </div>
            </div>
        </el-col>
</template>

<script>
	export default {
    name: 'app-footer',
    data () {
      return {
	
      }
    }   
  }
</script>
<style scoped>
	#footer{
        height:181px;
        background:rgba(35,25,22,1);
        z-index: 99;
    }
    #footer .fc{
       float:left;margin: 20px 0px 20px 5px;
    }
    #footer .footer_top{
        height: 120px;
        border-bottom: 1px solid rgba(60,44,40,1);
        color: #fff;
    }
    #footer .footer_top ul li{
        float: left;
        height: 120px;
        line-height: 120px;
        margin-left: 20px;
    }
    #footer .footer_top ul li a{
       color: #837A78;
        font-size: 14px;
    }
    #footer .footer_top ul li a.router-link-active{
        color: #fff;
    }

    #footer .footer_bottom{
        color: #837A78;
        font-size: 14px;
        height: 60px;
        line-height: 60px;
    }
</style>


// WEBPACK FOOTER //
// src/components/footer.vue